import { useState } from "react";

import { Button, Image, Separator, TextDisplay, Wrapper } from "src/styled";
import { translate } from "src/services";
import ConfirmationImage from "src/assets/images/confirmationTruck.png";
import ContactUsModal from "../../modals/ContactUsModal";

interface Props {
  handleScheduleAnotherPickup: () => void;
}

const ConfirmationScreen = ({ handleScheduleAnotherPickup }: Props) => {
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);

  return (
    <>
      <Wrapper width={250} margin="no auto">
        <Image src={ConfirmationImage} alt="truck" />
      </Wrapper>
      <TextDisplay size="xLarge" block weight="medium" margin="large no no" lineHeight="120%">
        {translate("wizardPage.confirmationHeading")}
      </TextDisplay>
      <Separator height={50} />
      <TextDisplay
        size="medium"
        margin="xSmall no no"
        desktopMargin="medium no no"
        lineHeight="120%"
      >
        {translate("wizardPage.confirmationSubHeading")}{" "}
        <Button color="primary" text padding="no" onClick={() => setIsContactUsModalOpen(true)}>
          {translate("wizardPage.contactUs")}
        </Button>{" "}
        {translate("wizardPage.confirmationSubHeading2")}
      </TextDisplay>
      <Separator height={150} />
      <Button
        type="submit"
        color="primary"
        size="medium"
        borderRadius="100px"
        onClick={handleScheduleAnotherPickup}
      >
        {translate("wizardPage.scheduleAnotherPickup")}
      </Button>
      <Separator height={100} />

      {isContactUsModalOpen && <ContactUsModal closeModal={() => setIsContactUsModalOpen(false)} />}
    </>
  );
};

export default ConfirmationScreen;
